const convertChainId = (id) => {
    let x = id.toString();
    if (x.substr(0, 2) == '0x') return id;
    else return '0x' + id.toString(16);
}
export default convertChainId;